import { render, staticRenderFns } from "./CustomViewManager.vue?vue&type=template&id=ae21f3c0&scoped=true&"
import script from "./CustomViewManager.vue?vue&type=script&lang=js&"
export * from "./CustomViewManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae21f3c0",
  null
  
)

export default component.exports